import { CLEAR_CREATE_TRANSACTION, SET_ON_SUBMIT_DETAILS } from "../action";
import { onSubmitDetails } from "./initial-store";

const initialState = onSubmitDetails;

function onSubmitDetailsReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_ON_SUBMIT_DETAILS:
      newState = {
        ...state,
        errorFields: action.payload.errorFields,
        errorFlag: action.payload.errorFlag,
      };
      return newState;

    case CLEAR_CREATE_TRANSACTION:
      newState = initialState;
      return newState;

    default:
      return state;
  }
}

export default onSubmitDetailsReducer;
